import { render, staticRenderFns } from "./ContactGenderSelector.vue?vue&type=template&id=f9d9927a"
import script from "./ContactGenderSelector.vue?vue&type=script&lang=ts"
export * from "./ContactGenderSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports